class Timeline extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.items = this.querySelectorAll('.timeline__item');
    this.media = this.querySelector('.timeline__col:first-child');
    this.addHandlers();
  }

  addHandlers() {
    const animationConfigElement = this.querySelector('#timelineLottieConfig');

    if (animationConfigElement) {
      this.animationConfig = lottie.loadAnimation({
        container: animationConfigElement,
        renderer: 'canvas',
        loop: false,
        autoplay: false,
        path: animationConfigElement.dataset.src,
      });

      this.animationConfig.addEventListener('DOMLoaded', () => {
        const endFrame = this.animationConfig.getDuration(true);
        const visibility = window.matchMedia('(min-width: 990px)').matches
          ? [0.5, 0.75]
          : [0.3, 0.7];

        LottieInteractivity.create({
          mode: 'scroll',
          player: this.animationConfig,
          container: '#timeline-list',
          actions: [
            {
              visibility,
              type: 'seek',
              frames: [0, endFrame],
            },
          ],
        });
      });
    }

    window.addEventListener('scroll', this.handleOnScroll.bind(this));
  }

  handleOnScroll() {
    this.items.forEach((item) => {
      const itemTop = item.getBoundingClientRect().top;
      const threshold = window.matchMedia('(min-width: 990px)').matches
        ? 120
        : this.media.offsetHeight * 1.5;

      item.classList.toggle('is-active', itemTop <= threshold);
    });
  }
}

customElements.define('component-timeline', Timeline);
